/* Saját kosár oldal: mennyiség, törlés, megjegyzés és ajánlók oldalújratöltés nélkül. */
(function () {
  if (window.__ekCartInit) return;
  window.__ekCartInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var pending = {};
  var timer;

  function cartEl() { return document.querySelector('[data-ek-cart]'); }

  function showError(msg) {
    var el = document.querySelector('[data-ek-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  /* A szekció újrarajzolása a Shopify válaszából */
  function render(sections) {
    var wrap = cartEl();
    if (!wrap || !sections) return;
    var html = sections[wrap.dataset.sectionId];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ek-cart-inner]');
      var current = wrap.querySelector('[data-ek-cart-inner]');
      if (fresh && current) {
        /* a már betöltött ajánlókat megtartjuk */
        var oldRecs = current.querySelector('[data-ek-recs]');
        var newRecs = fresh.querySelector('[data-ek-recs]');
        if (oldRecs && newRecs && !newRecs.hasAttribute('data-static') && oldRecs.dataset.loaded) {
          newRecs.replaceWith(oldRecs);
        }
        current.replaceWith(fresh);
        /* a beágyazott Teeinblue scriptek innerHTML-ből nem futnak le, újraindítjuk őket */
        fresh.querySelectorAll('script').forEach(function (old) {
          var s = document.createElement('script');
          s.textContent = old.textContent;
          old.replaceWith(s);
        });
      }
    }
    var bubble = sections['cart-icon-bubble'];
    var bubbleEl = document.getElementById('cart-icon-bubble');
    if (bubble && bubbleEl) {
      var b = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section');
      if (b) bubbleEl.innerHTML = b.innerHTML;
    }
    /* szállítási becslés újraszámolása */
    document.dispatchEvent(new Event('change'));
    setupSticky();
    loadRecs();
  }

  function update(updates) {
    var wrap = cartEl();
    if (!wrap) return Promise.resolve();
    busy = true;
    Object.keys(updates).forEach(function (key) {
      var line = wrap.querySelector('[data-ek-line][data-key="' + CSS.escape(key) + '"]');
      if (line) line.classList.add('is-loading');
    });
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: [wrap.dataset.sectionId, 'cart-icon-bubble'],
        sections_url: window.location.pathname + window.location.search
      })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) {
          showError(r.data.description || r.data.message || 'Nem sikerült frissíteni a kosarat.');
          return refresh();
        }
        showError('');
        render(r.data.sections);
      })
      .catch(function () {
        showError('Nem sikerült frissíteni a kosarat. Kérjük, töltsd újra az oldalt.');
      })
      .then(function () { busy = false; });
  }

  /* Hiba után a valós állapot betöltése */
  function refresh() {
    var wrap = cartEl();
    var url = window.location.pathname + window.location.search;
    url += (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + wrap.dataset.sectionId + ',cart-icon-bubble';
    return fetch(url).then(function (r) { return r.json(); }).then(render);
  }

  /* Extra (Teeinblue kiegészítő) hozzáadása a poszterhez, ugyanazzal a customization ID-val,
     ahogy a termékoldal is teszi */
  function addExtra(btn) {
    var wrap = cartEl();
    var row = btn.closest('.ek-extra');
    if (row) row.classList.add('is-loading');
    busy = true;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(btn.dataset.variant, 10),
          quantity: Math.max(1, parseInt(btn.dataset.qty, 10) || 1),
          properties: { _tib_customization_id: btn.dataset.cid }
        }],
        sections: [wrap.dataset.sectionId, 'cart-icon-bubble'],
        sections_url: window.location.pathname + window.location.search
      })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) {
          showError(r.data.description || r.data.message || 'Nem sikerült hozzáadni az extrát.');
          return refresh();
        }
        showError('');
        if (r.data.sections) render(r.data.sections);
        else return refresh();
      })
      .catch(function () { showError('Nem sikerült hozzáadni az extrát. Kérjük, töltsd újra az oldalt.'); })
      .then(function () { busy = false; });
  }

  /* Egy fő tétel új mennyisége; a hozzá tartozó Teeinblue kiegészítők arányosan követik */
  function setQty(line, qty) {
    qty = Math.max(0, parseInt(qty, 10) || 0);
    var oldQty = parseInt(line.dataset.qty, 10) || 0;
    if (qty === oldQty && !pending[line.dataset.key]) return;
    pending[line.dataset.key] = qty;
    var cid = line.dataset.cid;
    if (cid) {
      line.querySelectorAll('[data-ek-addon]').forEach(function (a) {
        var aq = parseInt(a.dataset.qty, 10) || 0;
        pending[a.dataset.key] = qty === 0 ? 0 : Math.max(1, Math.round(aq * qty / (oldQty || 1)));
      });
      /* a rendelésszintű expressz a poszterével együtt törlődik */
      if (qty === 0) {
        document.querySelectorAll('[data-ek-express-row][data-parent="' + CSS.escape(cid) + '"] [data-key]').forEach(function (b) {
          if (b.dataset.key) pending[b.dataset.key] = 0;
        });
      }
    }
    clearTimeout(timer);
    timer = setTimeout(flush, 400);
  }

  function flush() {
    if (busy) { timer = setTimeout(flush, 200); return; }
    var updates = pending;
    pending = {};
    if (Object.keys(updates).length) update(updates);
  }

  /* A megnyíló Teeinblue szerkesztőben a kattintott extra kérdéséhez görgetünk és kiemeljük */
  var FIELD_MATCH = { tores: /törés/i, okos: /okos/i, expressz: /expressz/i, digital: /digit/i };
  /* a mező legközelebbi ténylegesen görgethető szülője (a Teeinblue ablakban ez lehet a modal belseje is) */
  function scrollParent(el) {
    for (var p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
      var oy = getComputedStyle(p).overflowY;
      if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && p.scrollHeight > p.clientHeight + 1) return p;
    }
    return null;
  }
  function focusField(kind) {
    var re = FIELD_MATCH[kind];
    if (!re) return;
    var tries = 0;
    (function look() {
      var field = Array.prototype.find.call(
        document.querySelectorAll('.tee-customization-form .tee-field'),
        function (f) {
          var h = f.querySelector('.tee-field__heading');
          return h && f.offsetParent !== null && re.test(h.textContent);
        }
      );
      if (!field) {
        if (++tries < 40) setTimeout(look, 150);
        return;
      }
      /* Csak a Teeinblue ablak saját görgető dobozát görgetjük (scrollIntoView mobilon az egész oldalt,
         vele az X-et és a címet is feltolta), és megvárjuk, amíg a képek betöltése után megáll az elrendezés */
      var box = scrollParent(field);
      var lastH = -1, stable = 0, waits = 0;
      (function settle() {
        var h = (box || field.closest('.vm--container') || document.body).scrollHeight;
        stable = h === lastH ? stable + 1 : 0;
        lastH = h;
        if (stable < 3 && ++waits < 25) { setTimeout(settle, 120); return; }
        box = scrollParent(field) || box;
        if (box) {
          var fr = field.getBoundingClientRect(), br = box.getBoundingClientRect();
          var target = box.scrollTop + fr.top - br.top - (box.clientHeight - Math.min(fr.height, box.clientHeight)) / 2;
          box.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
        }
        field.classList.add('ek-tee-focus');
        setTimeout(function () { field.classList.remove('ek-tee-focus'); }, 2400);
      })();
    })();
  }

  /* A kosárból nyitott szerkesztőben a Teeinblue „A megadott adatokat … leellenőriztem” jelölőnégyzetét
     előre bepipáljuk (a vevő ezeket már egyszer jóváhagyta). A kosár oldalon minden látható Teeinblue űrlap
     a kosárból nyílt, ezért figyeljük a DOM-ot, és minden megnyitáskor egyszer bepipáljuk.
     (A valódi input rejtett, ezért a láthatóságot a burkolón nézzük.) */
  var confirmDone = false;
  function isShown(el) { return !!(el && el.getClientRects().length); }
  function checkConfirm() {
    var input = document.querySelector('.tee-checkbox__input[name="confirmed"]');
    var wrap = input && (input.closest('.tee-checkbox-wrapper') || input.parentElement);
    if (!isShown(wrap)) { confirmDone = false; return; }
    if (confirmDone) return;
    confirmDone = true;
    if (input.checked) return;
    var label = wrap.querySelector('label.tee-checkbox__label') ||
      document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    (label || input).click();
    setTimeout(function () {
      if (input.checked) return;
      var pseudo = wrap.querySelector('.tee-checkbox__pseudo');
      if (pseudo) pseudo.click();
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 200);
  }
  /* Fehér cím a Teeinblue szerkesztő ablak fölé, a bezáró X-szel egy sorba */
  var TITLE_TEXT = 'Termék és extrák személyre szabása';
  /* csak változáskor írunk, különben a DOM-figyelő újra és újra lefutna */
  function setStyle(el, prop, px) {
    var v = Math.round(px) + 'px';
    if (el.style[prop] !== v) el.style[prop] = v;
  }
  function isTransparent(el) {
    var bg = getComputedStyle(el).backgroundColor;
    return !bg || bg === 'transparent' || /rgba\(.*,\s*0\)$/.test(bg);
  }
  /* az első nem átlátszó hátterű elem a modalban (szélesség szerint a legnagyobb), legfeljebb 4 szint mélyen */
  function visibleBox(m) {
    var level = [m];
    for (var d = 0; d < 5; d++) {
      var hit = level.filter(function (el) { return !isTransparent(el) && el.offsetWidth > m.offsetWidth * .6; })[0];
      if (hit) return hit;
      var next = [];
      level.forEach(function (el) { next.push.apply(next, Array.prototype.filter.call(el.children, isShown)); });
      if (!next.length) break;
      level = next;
    }
    return m;
  }
  function placeTitle() {
    document.querySelectorAll('.vm--container').forEach(function (c) {
      var m = c.querySelector('.vm--modal');
      var t = c.querySelector(':scope > .ek-tee-modal-title');
      if (!m || !isShown(m) || !m.querySelector('.tee-customization-form, .tee-field, [name="confirmed"]')) {
        if (t) t.hidden = true;
        c.classList.remove('ek-has-title');
        return;
      }
      if (!t) {
        t = document.createElement('div');
        t.className = 'ek-tee-modal-title';
        t.textContent = TITLE_TEXT;
        c.appendChild(t);
      }
      /* a modal beúszó animációja és a lejjebb tolás (transform) közben rossz helyet mérnénk, ezért utána újramérünk */
      if (t.hidden || !c.classList.contains('ek-has-title')) {
        setTimeout(placeTitle, 120);
        setTimeout(placeTitle, 450);
        setTimeout(placeTitle, 900);
      }
      t.hidden = false;
      c.classList.add('ek-has-title');
      var cr = c.getBoundingClientRect(), mr = m.getBoundingClientRect();
      var close = Array.prototype.find.call(
        c.querySelectorAll('button, [role="button"], [class*="close"]'),
        function (b) { return !m.contains(b) && b !== t && isShown(b); }
      );
      var xr = close && close.getBoundingClientRect();
      /* középre zárva a modal fölé; a szélesség úgy, hogy ne lógjon az X alá (előbb a szélesség, mert a tördelés a magasságot is változtatja) */
      var mid = (mr.left + mr.right) / 2;
      var half = Math.min(mid - Math.max(cr.left + 12, mr.left), (xr ? xr.left - 12 : mr.right) - mid);
      /* fix szélességű, középre zárt doboz: így nem függ attól, mekkorára méretezi a böngésző a szöveget */
      half = Math.max(60, half);
      setStyle(t, 'width', half * 2);
      setStyle(t, 'left', mid - cr.left + c.scrollLeft - half);
      /* A függőleges helyet az elrendezésből (offsetTop) számoljuk, nem a látszó helyből: így a modal beúszó animációja
         és az asztali lejjebb tolás (CSS: translateY(2.4rem)) sem viszi el a címet */
      /* A Teeinblue modaljának lehet átlátszó felső sávja (abban ül az X): a látható (nem átlátszó hátterű) doboz tetejéhez igazodunk */
      var box = visibleBox(m);
      var inset = box.getBoundingClientRect().top - mr.top;
      var top;
      if (m.offsetParent === c) {
        var shift = window.matchMedia('(min-width: 750px)').matches ? parseFloat(getComputedStyle(document.documentElement).fontSize) * 2.4 : 0;
        top = m.offsetTop + shift + inset - t.offsetHeight - 8;
      } else {
        top = mr.top + inset - cr.top + c.scrollTop - t.offsetHeight - 8;
      }
      setStyle(t, 'top', Math.max(4, top));
    });
  }
  window.addEventListener('resize', placeTitle);
  document.addEventListener('transitionend', placeTitle, true);
  document.addEventListener('animationend', placeTitle, true);
  document.addEventListener('scroll', placeTitle, true);
  placeTitle();

  var confirmQueued = false;
  new MutationObserver(function () {
    if (confirmQueued) return;
    confirmQueued = true;
    setTimeout(function () { confirmQueued = false; checkConfirm(); placeTitle(); }, 120);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-ek-step]');
    if (step) {
      var line = step.closest('[data-ek-line]');
      var input = line.querySelector('[data-ek-qty]');
      var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.ekStep, 10));
      input.value = v;
      setQty(line, v);
      return;
    }
    var extra = e.target.closest('[data-ek-extra]');
    if (extra) {
      var act = extra.dataset.ekExtra;
      if (act === 'add') {
        addExtra(extra);
      } else if (act === 'remove' && extra.dataset.key) {
        extra.closest('.ek-extra').classList.add('is-loading');
        var upd = {};
        upd[extra.dataset.key] = 0;
        update(upd);
      } else if (act === 'edit') {
        /* A Teeinblue a tervhez köti a kiegészítőket (a törölt sort visszarakja), az Okosposzterhez
           adat is kell, ezért ezeket a Teeinblue szerkesztőben lehet módosítani */
        var ln = extra.closest('[data-ek-line]') ||
          document.querySelector('[data-ek-line][data-cid="' + CSS.escape(extra.dataset.cid || '') + '"]');
        var editBtn = ln && Array.prototype.find.call(
          ln.querySelectorAll('.ek-line__tools a, .ek-line__tools button'),
          function (el) { return /szerkeszt|edit/i.test(el.textContent); }
        );
        if (editBtn) { editBtn.click(); focusField(extra.dataset.kind); }
        else if (ln) window.location.href = ln.querySelector('.ek-line__title').href;
      }
      return;
    }
    var more = e.target.closest('[data-ek-more]');
    if (more) {
      var box = more.closest('[data-ek-more-box]');
      var open = box.classList.toggle('is-open');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var remove = e.target.closest('[data-ek-remove]');
    if (remove) {
      e.preventDefault();
      var l = remove.closest('[data-ek-line]');
      l.querySelector('[data-ek-qty]').value = 0;
      setQty(l, 0);
      clearTimeout(timer);
      flush();
      return;
    }
    var prev = e.target.closest('[data-ek-preview]');
    if (prev) {
      /* a Teeinblue saját „Előnézet” gombja ugyanazt az ablakot nyitja, mint a gombra kattintva */
      var pl = prev.closest('[data-ek-line]');
      var teeBtn = pl && pl.querySelector('.tee-preview-design :is(button, a, [role="button"])');
      if (teeBtn) {
        e.preventDefault();
        teeBtn.click();
      } else if (prev.dataset.ekPreview) {
        e.preventDefault();
        openPreview(prev.dataset.ekPreview, prev.dataset.ekPreviewTitle);
      }
      return;
    }
    if (e.target.matches('[data-ek-modal-close]') || e.target.matches('.ek-modal')) {
      e.target.closest('dialog').close();
      return;
    }
    var go = e.target.closest('[data-ek-sticky-go]');
    if (go) {
      var btn = document.querySelector('[data-ek-checkout]');
      if (btn) btn.click();
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches) return;
    if (e.target.matches('[data-ek-qty]')) {
      setQty(e.target.closest('[data-ek-line]'), e.target.value);
    } else if (e.target.matches('[data-ek-note]')) {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    } else if (e.target.matches('[data-ek-terms-input]') && e.target.checked) {
      var err = document.querySelector('[data-ek-terms-error]');
      if (err) err.hidden = true;
      e.target.closest('[data-ek-terms]').classList.remove('is-invalid');
    }
  });

  /* Enter a mennyiség mezőben ne küldje pénztárba a vásárlót */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ek-qty]')) {
      e.preventDefault();
      e.target.blur();
    }
  });

  /* Pénztár: ÁSZF ellenőrzése */
  document.addEventListener('submit', function (e) {
    if (e.target.id !== 'EmlekCartForm') return;
    var terms = e.target.querySelector('[data-ek-terms-input]');
    if (terms && !terms.checked) {
      e.preventDefault();
      var label = terms.closest('[data-ek-terms]');
      var err = document.querySelector('[data-ek-terms-error]');
      if (err) err.hidden = false;
      label.classList.remove('is-invalid');
      void label.offsetWidth;
      label.classList.add('is-invalid');
      label.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    /* el nem küldött mennyiségváltás esetén a form updates[] mezőit a Shopify a pénztár előtt elmenti */
  });

  /* A mentett terv (Teeinblue _customization_image) nagyban, felugró ablakban */
  function openPreview(src, title) {
    var dlg = document.getElementById('EkPreview');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.id = 'EkPreview';
      dlg.className = 'ek-modal';
      dlg.innerHTML = '<div class="ek-modal__head"><p class="ek-modal__title"></p>' +
        '<button type="button" class="ek-modal__close" data-ek-modal-close aria-label="Bezárás">×</button></div>' +
        '<img class="ek-modal__img" alt="">';
      document.body.appendChild(dlg);
    }
    dlg.querySelector('.ek-modal__title').textContent = title ? title + ' – előnézet' : 'Előnézet';
    var img = dlg.querySelector('.ek-modal__img');
    img.src = src;
    img.alt = title || '';
    if (dlg.showModal) dlg.showModal();
    else window.open(src, '_blank');
  }

  /* Mobilon a ragadós sáv eltűnik, amikor a valódi gomb látszik */
  var stickyObserver;
  function setupSticky() {
    var sticky = document.querySelector('[data-ek-sticky]');
    var btn = document.querySelector('[data-ek-checkout]');
    if (stickyObserver) stickyObserver.disconnect();
    if (!sticky || !btn || !('IntersectionObserver' in window)) return;
    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var hide = en.isIntersecting || en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-hidden', hide);
      });
    });
    stickyObserver.observe(btn);
  }

  /* Pénzformátum a bolt beállítása szerint ({{amount_no_decimals_with_comma_separator}} stb.) */
  function money(cents) {
    var wrap = cartEl();
    var format = (wrap && wrap.dataset.moneyFormat) || '{{amount_no_decimals}} Ft';
    function fmt(n, dec, th, ds) {
      var p = (n / 100).toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 0, ' ', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* Ajánlók a Shopify automatikus ajánlásaiból, ha nincs kollekció beállítva */
  function loadRecs() {
    var recs = document.querySelector('[data-ek-recs]');
    if (!recs || recs.hasAttribute('data-static') || recs.dataset.loaded || !recs.dataset.productId) return;
    recs.dataset.loaded = '1';
    var exclude = (recs.dataset.exclude || '').split(',');
    var limit = parseInt(recs.dataset.limit, 10) || 8;
    fetch(root + 'recommendations/products.json?limit=' + (limit + exclude.length) + '&product_id=' + recs.dataset.productId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = recs.querySelector('[data-ek-recs-list]');
        var html = (data.products || [])
          .filter(function (p) { return exclude.indexOf(String(p.id)) === -1 && p.available; })
          .slice(0, limit)
          .map(function (p) {
            var img = p.featured_image ? p.featured_image.replace(/(\.\w+)(\?|$)/, '_400x$1$2') : '';
            if (img.indexOf('//') === 0) img = 'https:' + img;
            var price = p.price_varies ? money(p.price_min) + '-tól' : money(p.price);
            return '<li class="ek-card"><a href="' + esc(p.url) + '">' +
              '<span class="ek-card__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="400" height="400">' : '') + '</span>' +
              '<span class="ek-card__title">' + esc(p.title) + '</span>' +
              '<span class="ek-card__price">' + esc(price) + '</span>' +
              '<span class="ek-card__cta">Megnézem</span></a></li>';
          }).join('');
        list.innerHTML = html;
      })
      .catch(function () {});
  }

  function init() {
    setupSticky();
    loadRecs();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
